import React from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import '../styles/MemberLogin.css';
import { useNavigate } from 'react-router-dom';

const EDCCMemberLogin = () => {
  const navigate = useNavigate();
  
  return (
    <>
      <section className="member-login-section">
        <Container>
          <div className="login-box">
            <Row>
              <Col md={6} className="login-left mb-4 mb-md-0">
              <div className="login-form-container">
                <h4 className="login-title">
                  EDCC Register
                </h4>
                </div>
              </Col>

              <Col md={6}>
                <Form>
                  <Form.Group controlId="formEmail" className="mb-4">
                    <Form.Label>Company Email ID</Form.Label>
                    <Form.Control type="email" placeholder="Enter your Email" />
                  </Form.Group>
                  <Form.Group controlId="formPassword" className="mb-3">
                    <Form.Label>Password</Form.Label>
                    <Form.Control type="password" placeholder="Password" />
                  </Form.Group>
                  <Form.Group controlId="formNumber" className='mb-3'>
                    <Form.Label>Mobile Number</Form.Label>
                    <Form.Control type="text" placeholder="Enter your Mobile Number" />
                  </Form.Group>
                   <Form.Group controlId="formPassword" className="mb-3">
                    <Form.Label>Confirm Password</Form.Label>
                    <Form.Control type="password" placeholder="Password" />
                  </Form.Group> 

                

                 <div className="text-center mb-3">
          <Button className="custom-btn" onClick={() => navigate('/EDCCterms-conditions')}>
            next
          </Button>
        </div>

                  <div className="bottom-text">
  Click here to <span className="custom-link" onClick={() => navigate('/edcc-login')} style={{ cursor: 'pointer' }}>Sign In</span>
</div>

                </Form>
              </Col>
            </Row>
          </div>
        </Container>
      </section>

    </>
  );
};

export default EDCCMemberLogin;